import { PersonsCommunicationPreferencesService_personCommunicationPreferenceServiceGetEntities as service } from '@festina/legalentity-general-types/legalentity/hooks/PersonsCommunicationPreferencesService_personCommunicationPreferenceServiceGetEntities'

export const useFetchCommunicationPreferences = service.useSuspenseQuery
